// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__phlFo","info":"PatientInfo_info__27EIg"};